import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./context/authContext";
import { useEffect, useState } from "react";
import api from "./api";
import { LoadScript } from "@react-google-maps/api";
import LoginPage from "./pages/LoginPage";
import UsersPage from "./pages/UsersPage";
import ClientsPage from "./pages/ClientsPage";
import ClientDetailsPage from "./pages/ClientDetailsPage";
import DriversPage from "./pages/DriversPage";
import DriverDetailsPage from "./pages/DriverDetailsPage";
import UserDetailsPage from "./pages/UserDetailsPage";
import CarsPage from "./pages/CarsPage";
import CarDetailsPage from "./pages/CarDetailsPage";
import RidesPage from "./pages/RidesPage";
import RideDetailsPage from "./pages/RideDetailsPage";
import ProfilePage from "./pages/ProfilePage";
import ReportsPage from "./pages/ReportsPage";
import ConfirmRide from "./pages/ConfirmRide";
import QuoterPage from "./pages/QuoterPage";
import RatingScreen from "./pages/RatingScreen";
import ProtectedRoute from "./components/ProtectedRoute";
import Spinner from "./components/Spinner";

function App() {
  const auth = useAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de carga

  useEffect(() => {
    async function fetchMe() {
      try {
        const response = await api.users.getMe();
        setUser(response);
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false); // Finaliza la carga
      }
    }

    if (auth.isAuthenticated) {
      fetchMe();
    } else {
      setLoading(false); // Si no está autenticado, no hace falta cargar usuario
    }
  }, [auth.isAuthenticated]);

  if (loading) {
    return <Spinner />; // Puedes reemplazarlo con un spinner o pantalla de carga
  }

  return (
    <Router>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["places"]}
      >
        <Routes>
          {auth.isAuthenticated ? (
            <>
              <Route
                exact
                path="/users/:id"
                element={
                  <ProtectedRoute
                    element={UserDetailsPage}
                    allowedRoles={[2]}
                    user={user}
                  />
                }
              />
              <Route
                exact
                path="/users"
                element={
                  <ProtectedRoute
                    element={UsersPage}
                    allowedRoles={[2]}
                    user={user}
                  />
                }
              />
              <Route
                exact
                path="/reports"
                element={
                  <ProtectedRoute
                    element={ReportsPage}
                    allowedRoles={[2]}
                    user={user}
                  />
                }
              />
              <Route exact path="/rides" element={<RidesPage />} />
              <Route path="/rides/:id" element={<RideDetailsPage />} />
              <Route path="/quoter" element={<QuoterPage />} />
              <Route exact path="/clients" element={<ClientsPage />} />
              <Route exact path="/cars" element={<CarsPage />} />
              <Route exact path="/cars/:id" element={<CarDetailsPage />} />
              <Route path="/clients/:id" element={<ClientDetailsPage />} />
              <Route exact path="/drivers" element={<DriversPage />} />
              <Route path="/drivers/:id" element={<DriverDetailsPage />} />
              <Route exact path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<Navigate to="/rides" />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/rides/:token/confirm" element={<ConfirmRide />} />
              <Route
                exact
                path="rides/:token/review"
                element={<RatingScreen />}
              />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
        </Routes>
      </LoadScript>
    </Router>
  );
}

export default App;
